import React, { useContext, useEffect } from "react";
import { EntradasContext } from "../../context/EntradasContext";
import Retraso from "../bitacora/Retraso";
import BitacoraInput from "../bitacora/BitacoraInput";
import { RetrasosContext } from "../../context/RetrasosContext";
import { ProyectosContext } from "../../context/ProyectosContext";
import { AuthContext } from "../../context/AuthContext";
import { AppConfigContext } from "../../context/AppConfigContext";
import { getValue } from "../../utils";

const Retrasos = ({ partida }) => {
  const { user } = useContext(AuthContext);
  const appconfig = useContext(AppConfigContext);
  const { proyecto } = useContext(ProyectosContext);
  const { entradasPartida, getEntradasPartida } = useContext(EntradasContext);
  const { postRetraso } = useContext(RetrasosContext);

  const { idProyecto, permiso } = proyecto;

  const fetchEntradas = () => {
    if (partida) getEntradasPartida(idProyecto, partida.idPartida);
  };

  useEffect(() => {
    fetchEntradas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partida?.idPartida]);

  function renderRetrasos() {
    if (!Array.isArray(entradasPartida)) {
      return <div className="spinner-border spinner-border-sm" />;
    }
    if (entradasPartida.length === 0) {
      return "No hay comentarios para esta partida";
    }
    return entradasPartida.map((entrada) => (
      <div key={"entrada-" + entrada.idEntrada}>
        {entrada.retraso && (
          <span className="badge bg-danger mb-1">Retraso</span>
        )}
        <Retraso retraso={entrada} uid={user.uid} hideImage />
      </div>
    ));
  }

  function handlePostRetraso(contenido) {
    postRetraso(
      idProyecto,
      {
        contenido,
        retraso: true,
        idPartida: partida.idPartida,
      },
      fetchEntradas
    );
  }

  function renderInput() {
    if (["admin", "supervisor"].includes(permiso))
      return (
        <BitacoraInput
          modifier={handlePostRetraso}
          placeholder="Escribe un nuevo comentario"
        />
      );
  }

  function retrasado() {
    if (getValue(appconfig, "progress") === "money") {
      return parseFloat(partida.progreso) / 100 < partida.programado;
    }
    return partida.real < partida.programado;
  }

  return (
    <div className="bg-light position-relative p-3">
      <h5>{partida.nombre}</h5>
      <h6 className={retrasado() ? "text-danger" : "text-success"}>
        {retrasado() ? " Retraso\n" : " A tiempo\n"}
      </h6>
      <div style={{ minHeight: 250 }}>{renderRetrasos()}</div>
      {renderInput()}
    </div>
  );
};

export default Retrasos;
